// src/routes.js
import React, { Component } from "react";
import { BrowserRouter as Router, Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { pathToJS, firebaseConnect } from "react-redux-firebase";

import App from "./App";
import CreateAccount from "./routes/create-account/";
import Login from "./routes/login/";
import Account from "./routes/account/";
import Admin from "./routes/admin/";

import GroupDashboard from "./routes/group-dashboard/";
import GroupLogs from "./routes/group-logs/";
import Log from "./routes/log/";
import PrintStudentLog from "./routes/print-student-log/";
import PrintLog from "./routes/print-log/";
import Resource from "./routes/resource/";
import ResourceEdit from "./routes/edit-resource/";
import Blank from "./routes/blank/";
import GroupStudents from "./routes/group-students/";
import Menu from "./containers/menu/";

import ViewStudentLog from "./routes/view-student-log/";
import EditLog from "./routes/edit-log/";

import { StoreInstance } from "./index.js";

import Sidebar from "react-sidebar";

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props => {
      console.log(rest.auth);
      return rest.auth !== null
        ? rest.auth ? <Component {...props} auth={rest.auth} /> : <Blank />
        : <Redirect
            to={{
              pathname: "/login",
              state: { from: props.location }
            }}
          />;
    }}
  />
);

const mql = window.matchMedia(`(min-width: 800px)`);

class Routes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAuthenticated: !!props.user,
      mql: mql,
      docked: props.docked
    };
    this.mediaQueryChanged = this.mediaQueryChanged.bind(this);
  }
  componentWillReceiveProps(props) {
    this.state = {
      isAuthenticated: !!props.user,
      mql: mql,
      docked: props.docked
    };
    this.setState({ mql: mql, sidebarDocked: mql.matches });
  }

  componentWillMount() {
    mql.addListener(this.mediaQueryChanged);
    this.setState({ mql: mql, sidebarDocked: mql.matches });
  }

  componentWillUnmount() {
    this.state.mql.removeListener(this.mediaQueryChanged);
  }

  mediaQueryChanged() {
    this.setState({ sidebarDocked: this.state.mql.matches });
  }
  onSetSidebarOpen(open) {
    open
      ? this.props.dispatch({ type: "OPEN_DRAWER" })
      : this.props.dispatch({ type: "CLOSE_DRAWER" });
  }

  render() {
    return (
      <Router>
        <Sidebar
          sidebar={
            <PrivateRoute
              auth={this.props.auth}
              path="/group/:groupId/:log?/:logId?"
              component={Menu}
            />
          }
          open={this.props.drawerOpen}
          docked={!!this.props.auth && this.state.sidebarDocked}
          onSetOpen={this.onSetSidebarOpen.bind(this)}
          shadow={false}
          styles={{ sidebar: { display: "flex" } }}
        >
          <div className="routeContainer" onClick={console.log("foo")}>
            <Route path="/login" component={Login} />
            <Route path="/account/create/:email?" component={CreateAccount} />
            <Route
              auth={this.props.auth}
              exact
              path="/"
              render={() => (
                <Redirect
                  to={{
                    pathname: "/group/-KiqhK57QJfMXKizt8nc",
                    state: { from: this.props.location }
                  }}
                />
              )}
            />
            <PrivateRoute
              auth={this.props.auth}
              exact
              path="/account"
              component={Account}
            />
            <PrivateRoute
              auth={this.props.auth}
              path="/admin"
              exact
              component={Admin}
            />
            <PrivateRoute
              auth={this.props.auth}
              path="/group/:groupId"
              exact
              component={GroupDashboard}
            />

            <PrivateRoute
              auth={this.props.auth}
              path="/group/:groupId/logs"
              exact
              component={GroupLogs}
            />

            <PrivateRoute
              auth={this.props.auth}
              path="/group/:groupId/students"
              exact
              component={GroupStudents}
            />
            <PrivateRoute
              auth={this.props.auth}
              path="/group/:groupId/log/:logId"
              exact
              component={Log}
            />
            <PrivateRoute
              auth={this.props.auth}
              path="/group/:groupId/log/:logId/edit"
              exact
              component={EditLog}
            />
            <PrivateRoute
              auth={this.props.auth}
              path="/group/:groupId/resource/:resourceId"
              exact
              component={Resource}
            />
            <PrivateRoute
              auth={this.props.auth}
              path="/group/:groupId/resource/:resourceId/edit"
              exact
              component={ResourceEdit}
            />
            <PrivateRoute
              auth={this.props.auth}
              path="/print/group/:groupId/log/:logId/student/:studentId"
              exact
              component={PrintStudentLog}
            />
            <PrivateRoute
              auth={this.props.auth}
              path="/print/group/:groupId/log/:logId/role/:role"
              exact
              component={PrintLog}
            />
          </div>
        </Sidebar>
      </Router>
    );
  }
}

export default connect(
  // Map state to props
  ({ firebase, drawer }) => {
    return {
      drawerOpen: drawer.isOpen,
      authError: pathToJS(firebase, "authError"),
      auth: pathToJS(firebase, "auth"),
      profile: pathToJS(firebase, "profile")
    };
  }
)(firebaseConnect()(Routes));



// WEBPACK FOOTER //
// ./src/routes.js